import React, { useCallback } from "react";
import PropTypes from "prop-types";
import EntitiesSelector, { commonPropTypes } from "./entities-selector";
import { injectIntl } from "react-intl";

const query = `
  query EventStatuses {
    eventStatuses {
      items
      total
    }
  }
`;

const EventStatusSelect = ({
  intl,
  multiple = false,
  id = "eventStatus",
  name = "eventStatus",
  isInsideForm,
  ...props
}) => {
  const handleDataFromResponse = useCallback(data => data.eventStatuses, []);
  const handleGetValue = useCallback(element => element, []);
  const handleGetLabel = useCallback(element => intl.formatMessage({ id: `event.eventStatus.in.${element}` }), [intl]);

  return (
    <EntitiesSelector
      isInsideForm={isInsideForm}
      id={id}
      name={name}
      queryString={query}
      onGetDataFromResponse={handleDataFromResponse}
      onGetValue={handleGetValue}
      onGetLabel={handleGetLabel}
      {...props}
    />
  );
};

EventStatusSelect.propTypes = {
  ...commonPropTypes,
  /**
   * Valor del selector
   */
  selectedElement: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  /**
   * Valor del selector
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  /**
   * Contrato para el que se mostrarán los tipos de evento
   */
  contractId: PropTypes.string,
};

export default injectIntl(EventStatusSelect);
